import { argHttp } from 'services/ConfigurationService';

/**
 * Retrieves the default payment provider for USD currency.
 *
 * Sends a GET request to the `/paymentprovider/USD` endpoint using the configured HTTP client.
 *
 * @returns A promise that resolves with the payment provider data for USD.
 */
export const getDefaultPaymentProvider = () =>
  argHttp.get('/paymentprovider/USD');
